import React from 'react';
import appStoreBadge from '../../../public/static/images/rat-race/app-store.png';
import ratRaceAnimation from '../../../public/static/images/rat-race/ratRaceAnimation.mp4';
import styles from './index.module.scss';

const getAssetSrc = (asset) => asset?.src || asset;
const RAT_RACE_VIDEO_SRC = getAssetSrc(ratRaceAnimation);

export default function RatRaceFooter({ policyBasePath = '/rat-race' }) {
  return (
    <>
      <section className={styles.footerDesktopSection}>
        <div className={styles.footerDesktopInner}>
          <div className={styles.footerMainContent}>
            <video
              className={styles.footerRatMedia}
              autoPlay
              loop
              muted
              playsInline
              aria-label="Motivating rat"
            >
              <source src={RAT_RACE_VIDEO_SRC} type="video/mp4" />
            </video>
            <h2 className={styles.footerHeading}>Ready To Get Moving?</h2>
            <p className={styles.footerSubheading}>
              Small steps. Big wins. One very stylish rat.
            </p>
            <div className={styles.footerCtaArea}>
              <p className={styles.footerLaunchCopy}>
                Be the first to walk with Rat Race.
              </p>
              <button type="button" className={styles.footerCtaButton}>
                Download The App
              </button>
              <button type="button" className={styles.footerStoreButton}>
                <img
                  className={styles.footerStoreBadge}
                  src={getAssetSrc(appStoreBadge)}
                  alt="Download on the App Store"
                />
              </button>
            </div>
          </div>
          <div className={styles.footerLegalFooter}>
            <div className={styles.footerLegalInner}>
              <p className={styles.footerPolicyLinks}>
                <a href={`${policyBasePath}/privacy-policy`}>
                  Privacy policy
                </a>{' '}
                |{' '}
                <a href={`${policyBasePath}/user-agreement`}>
                  User agreement
                </a>
              </p>
              <p className={styles.footerDataLinks}>
                Do not sell or share my personal information
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
